import { render } from "./CalendarYear.vue?vue&type=template&id=01276754&scoped=true&ts=true"
import script from "./CalendarYear.vue?vue&type=script&lang=ts"
export * from "./CalendarYear.vue?vue&type=script&lang=ts"

import "./CalendarYear.vue?vue&type=style&index=0&id=01276754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01276754"]])

export default __exports__